






































	// @ts-ignore
    import _ from './MSecondaryDomainSubscribe.ts'; export default _;
